import { CIMSTags } from '../..'
import { useUserTagProps } from './hooks/useUserTagProps'
import { UserTagsProps } from './types'

/**
 * renders a {@link CIMSTags} component for User records
 *
 * @param props {@link UserTagsProps}
 * @returns
 */
const UserTags: React.FC<UserTagsProps> = ({ users }) => {
  const props = useUserTagProps()
  return <CIMSTags tags={users.map(props)} />
}

export default UserTags
